
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

export { fails as default };
//# sourceMappingURL=fails.js.map
